import React, { useEffect, useState } from 'react';
import { Notification } from 'types/api.types';
import { selectUserProfile } from 'core/redux/userSlice';
import { useAppDispatch, useAppSelector } from 'commons/store/hooks';
import NavBar from './../DashboardNavBar';
import DashboardSidebarBar, { SidebarItem } from './../DashboardSidebarBar';
import DashboardNotifyBar from './../DashboardNotifyBar';
import {
    ROUTES_USERS,
    ROUTES_DASHBOARD,
} from 'commons/constants/paths';
import { roles } from 'commons/auth/roles';
import { fetchNotifications, selectNotifications } from 'features/notifications/redux/notificationsSlice';
import { CODENAME } from 'commons/constants/env';
import { useTranslation } from "react-i18next";
import { fetchNavigations, selectNavigations } from "../../../../../features/page/redux/navigationSlice";

export interface NavProps {
    notificationsData?: {
        newNotificationsCounter?: number;
        notificationsListOptions: Notification[];
    };
}

const Nav = () => {
    const dispatch = useAppDispatch();
    const navigation = useAppSelector(selectNavigations);
    const notifications = useAppSelector(selectNotifications);
    const userProfile = useAppSelector(selectUserProfile);
    const { t } = useTranslation();

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isNotifyListOpen, setIsNotifyListOpen] = useState(false);
    const itemsPerPage = 15;

    const fetchData = async () => {
        if (!['FAKE'].includes(CODENAME)) {
            await dispatch(fetchNavigations({
                pagination: true,
                itemsPerPage,
                page: 1,
                location: 1,
            }));
        }
    };

    const fetch = () => {
        dispatch(fetchNotifications({ page: 1, itemsPerPage }));
    };

    useEffect(() => {
        fetchData();
        fetch();
        const interval = setInterval(async () => {
            await fetch;
        }, 60000);
        return () => clearInterval(interval);
    }, []);

    let allowed = userProfile.roles.some((role: string) => roles.admin.includes(role));

    const navVariant = () => {
        switch (CODENAME) {
            default: {
                const sidebarItemsData: SidebarItem[] = [
                    {
                        variant: 'routerLink',
                        label: t('main-panel'),
                        subLabel: t('main-panel-desc'),
                        to: ROUTES_DASHBOARD.DASHBOARD,
                        isShowing: true,
                        renderBottomLine: true,
                    },
                ];

                const navItems: SidebarItem[] = []
                let length = navigation.length;

                for (const navItem of navigation) {
                    navItems.push({
                        variant: 'routerLink',
                        label: navItem?.title,
                        subLabel: navItem?.description,
                        to: navItem?.src,
                        isShowing: true,
                        renderBottomLine: (!--length),
                        attr: navItem?.options?.attr
                    });
                }

                const sidebarSecondItems: SidebarItem[] = [
                    {
                        variant: 'routerLink',
                        label: t('users'),
                        to: ROUTES_USERS.LIST,
                        isShowing: allowed,
                    },
                ];

                return [...sidebarItemsData, ...navItems, ...sidebarSecondItems];
            }
        }
    };

    return (
        <>
            <NavBar
                onBurgerIconClick={() => setIsSidebarOpen((prev) => !prev)}
                newNotificationsCounter={notifications?.filter((el) => el.seenAt === null).length}
                onNotifyIconClick={() => setIsNotifyListOpen((prev) => !prev)}
            />
            <DashboardSidebarBar
                isOpen={isSidebarOpen}
                onClose={() => setIsSidebarOpen(false)}
                sidebarItemsData={navVariant()}
                user={userProfile}
            />
            <DashboardNotifyBar
                isOpen={isNotifyListOpen}
                onClose={() => setIsNotifyListOpen((prev) => !prev)}
                notifications={notifications}
            />
        </>
    );
};

export default Nav;